export const version = 'kunde-v1.20.0-SNAPSHOT-250f6f2e03ad219d6192da88b0617f7ee3f885b6';